module.exports = __webpack_public_path__ + "static/media/bphtb6.89767fe1.png";